export default (element: any) =>
  !element.name.includes('gender') &&
  Boolean(element.value) &&
  !Boolean(element.readOnly)
